var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.1326 5.26194C3.89175 5.75831 4.60986 6.25468 5.34849 6.75104C6.4154 7.45557 7.48231 8.1761 8.5287 8.88062C8.79543 9.05675 8.91854 9.29693 8.83647 9.56913C8.7544 9.84134 8.52871 10.0175 8.17991 10.0975C7.89266 10.1616 7.62593 10.0975 7.37972 9.93741C5.9435 8.9767 4.48675 8.01598 3.05053 7.03926C2.435 6.63896 1.81948 6.22265 1.22447 5.82236C0.711531 5.48611 0.732049 5.02176 1.22447 4.68551C3.27622 3.30849 5.32797 1.94748 7.37972 0.570456C7.79007 0.298254 8.34404 0.314266 8.67232 0.618492C9.0006 0.922718 8.95957 1.35504 8.5287 1.62724C6.78471 2.79611 5.04073 3.94896 3.29674 5.11783C3.27622 5.14986 3.21467 5.19789 3.1326 5.26194Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowR);
export default __webpack_public_path__ + "static/media/arrow_r.c465c0970dcbd5c2e93e59fbf0c650dc.svg";
export { ForwardRef as ReactComponent };